import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { Checkbox, FormControlLabel, FormGroup, IconButton, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toast } from "react-toastify";
import { GridDeleteIcon } from "@mui/x-data-grid";

export default function IBCalculator({ user, index }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expand, setExpand] = useState();
  const imageRefs = useRef([]);

  let userToken = localStorage.getItem("userToken");


  useEffect(() => {
    let docs = langs.map((item) => ({
      language: item.attributes.language,
      title: "",
      desc: "",
      firstResLabel: "",
      secondResLabel: "",
      thirdResLabel: "",
      levels: [
        {
          label: "New Level",
          usersLabel: "",
          lotLabel: "",
          cpaLabel: "",
          minUsers: "",
          maxUsers: "",
          minLot: "",
          maxLot: "",
          lotPrice: "",
          minCPA: "",
          maxCPA: "",
          cpaAmount: "",
        },
      ],
    }));
    setData(docs);

    async function getData() {
      await fetch(`${API}/partnership`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.calculator || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                title: apiItem.title || localItem.title,
                desc: apiItem.desc || localItem.desc,
                firstResLabel: apiItem.firstResLabel || localItem.firstResLabel,
                secondResLabel: apiItem.secondResLabel || localItem.secondResLabel,
                thirdResLabel: apiItem.thirdResLabel || localItem.thirdResLabel,
                levels: apiItem.levels || localItem.levels,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const handleInputChange = (e, index, levelIndex, field) => {
    const newValue = e.target.value;
    setData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index].levels[levelIndex][field] = newValue;
      return updatedData;
    });
  };

  const submitData = () => {
    fetch(`${API}/partnership`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { calculator: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const deleteLevel = (index, idx) => {
    const filteredLevels = data.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          levels: item.levels.filter((_, levelIndex) => levelIndex !== idx),
        };
      }
      return item;
    });

    setData(filteredLevels);
  };

  return (
    <div>
      <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
      <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

      <div
        style={{
          pointerEvents: user.perms[30].edit ? null : "none",
        }}>
        <TextField
          label="Title"
          sx={{ width: 500, marginBottom: 2 }}
          value={data[index]?.title || ""}
          onChange={(e) => {
            const newData = [...data];
            newData[index].title = e.target.value;
            setData(newData);
          }}
        />

        <TextField
          label="Description"
          multiline
          rows={3}
          sx={{ width: 500, marginBottom: 2 }}
          value={data[index]?.desc || ""}
          onChange={(e) => {
            const newData = [...data];
            newData[index].desc = e.target.value;
            setData(newData);
          }}
        />

        <div className="flex-col gap-3 mb-5" style={{ alignItems: "flex-start" }}>
          <h3 className="mb-2 mt-3">Result Labels</h3>

          <TextField
            label="First Label"
            sx={{ width: 300 }}
            value={data[index]?.firstResLabel || ""}
            onChange={(e) => {
              const newData = [...data];
              newData[index].firstResLabel = e.target.value;
              setData(newData);
            }}
          />
          <TextField
            label="Second Label"
            sx={{ width: 300 }}
            value={data[index]?.secondResLabel || ""}
            onChange={(e) => {
              const newData = [...data];
              newData[index].secondResLabel = e.target.value;
              setData(newData);
            }}
          />
          <TextField
            label="Third Label"
            sx={{ width: 300 }}
            value={data[index]?.thirdResLabel || ""}
            onChange={(e) => {
              const newData = [...data];
              newData[index].thirdResLabel = e.target.value;
              setData(newData);
            }}
          />
        </div>

        {data[index]?.levels?.map((item, idx) => (
          <div key={idx} className="relative">
            <div
              className="p-4 w-[95%] rounded-md shadow-md mb-2 transition-all delay-100 cursor-pointer overflow-hidden border relative"
              style={{
                maxHeight: expand == idx ? 650 : 60,
                minHeight: 60,
              }}
              onClick={() => {
                if (expand == idx) {
                  setExpand(null);
                } else {
                  setExpand(idx);
                }
              }}>
              <KeyboardArrowDownIcon
                style={{
                  transform: expand == idx ? "rotate(180deg)" : null,
                  transition: "0.2s",
                  fontSize: 30,
                  marginRight: 7,
                }}
              />
              {item.label}
              <div
                className="w-full mt-4 p-4 flex-col flex-wrap gap-6"
                style={{
                  transition: "0.3s",
                  visibility: expand == idx ? "visible" : "hidden",
                  opacity: expand == idx ? 1 : 0,
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  cursor: "auto",
                }}
                onClick={(e) => e.stopPropagation()}>
                <div
                  style={{
                    minWidth: 300,
                  }}>
                  <TextField
                    sx={{ width: "100%" }}
                    label="Level Name"
                    variant="outlined"
                    value={data[index]?.levels[idx]?.label || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "label")}
                  />
                </div>
                <TextField
                  sx={{ width: 300 }}
                  label="Users Label"
                  variant="outlined"
                  value={data[index]?.levels[idx]?.usersLabel || ""}
                  onChange={(e) => handleInputChange(e, index, idx, "usersLabel")}
                />
                <div className="flex">
                  <h3>Users Range:&nbsp;&nbsp;</h3>
                  <p>From&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.minUsers || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "minUsers")}
                  />
                  <p>&nbsp;&nbsp;To&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.maxUsers || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "maxUsers")}
                  />
                </div>

                <TextField
                  sx={{ width: 300 }}
                  label="LOT Label"
                  variant="outlined"
                  value={data[index]?.levels[idx]?.lotLabel || ""}
                  onChange={(e) => handleInputChange(e, index, idx, "lotLabel")}
                />
                <div className="flex">
                  <h3>Price of 1 Lot&nbsp;&nbsp;</h3>
                  <TextField
                    sx={{ width: 130, mr: 3 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.lotPrice || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "lotPrice")}
                  />
                  <h3>Lot Range:&nbsp;&nbsp;</h3>
                  <p>From&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.minLot || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "minLot")}
                  />
                  <p>&nbsp;&nbsp;To&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.maxLot || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "maxLot")}
                  />
                </div>
                <TextField
                  sx={{ width: 300 }}
                  label="CPA Label"
                  variant="outlined"
                  value={data[index]?.levels[idx]?.cpaLabel || ""}
                  onChange={(e) => handleInputChange(e, index, idx, "cpaLabel")}
                />
                <div className="flex">
                  <h3>CPA Percentage&nbsp;&nbsp;</h3>
                  <TextField
                    sx={{ width: 130, mr: 3 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.cpaAmount || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "cpaAmount")}
                  />
                  <h3>CPA Range:&nbsp;&nbsp;</h3>
                  <p>From&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.minCPA || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "minCPA")}
                  />
                  <p>&nbsp;&nbsp;To&nbsp;&nbsp;</p>
                  <TextField
                    sx={{ width: 130 }}
                    variant="outlined"
                    value={data[index]?.levels[idx]?.maxCPA || ""}
                    onChange={(e) => handleInputChange(e, index, idx, "maxCPA")}
                  />
                </div>
              </div>
            </div>
            <IconButton
              onClick={() => deleteLevel(index, idx)}
              style={{ position: "absolute", top: 10, right: 0, zIndex: 9999 }}>
              <GridDeleteIcon />
            </IconButton>
          </div>
        ))}
      </div>
      {user.perms[30].edit && (
        <div
          className="submitBTN"
          style={{ background: "#16a34a" }}
          onClick={() => {
            const newData = [...data];

            newData[index]?.levels?.push({
              label: "New Level",
              usersLabel: "",
              lotLabel: "",
              cpaLabel: "",
              minUsers: "",
              maxUsers: "",
              minLot: "",
              maxLot: "",
              lotPrice: "",
              minCPA: "",
              maxCPA: "",
              cpaAmount: "",
            });

            setData(newData);
          }}>
          Add New Level
        </div>
      )}
      {user.perms[30].edit && (
        <div className="submitBTN" onClick={() => submitData()}>
          Save Changes
        </div>
      )}
    </div>
  );
}
